<template>
  <div class="realTimeMonitoringDetail">
    <div class="filters">
      <div class="topBox">
        <div class="address">{{ruleForm.Place}}</div>
        <el-button type="primary" @click="back">返回上一级</el-button>
      </div>

      <!-- <div class="layBox">
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">困人事件</div>
        </div>
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">报警事件</div>
        </div>
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">故障事件</div>
        </div>
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">智能事件</div>
        </div>
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">使用年限</div>
        </div>
      </div> -->
    </div>
    <div class="cardBox wid100">
      <!-- 运行数据 -->
      <el-card class="cardFlex">
        <div class="yxsj">
          <div class="cardFlexTitle">运行数据</div>
          <div>
            <span>实时数据推送：</span>
            <el-switch style="margin-right:20px;" @change="switchChange" v-model="switchValue">
            </el-switch>
            <el-button type="primary" @click="highRate">高频</el-button>
            <el-button type="primary" @click="lowRate">低频</el-button>
          </div>

        </div>
        <div class="box">
          <div class="leftBox">
            <cameraPlayer v-if="ruleForm.YsNumber" :videoCode="ruleForm.YsNumber" :audoCode="ruleForm.YsNumber" :wsUrl="'ws://139.9.116.226:181'" :mediaIp="'139.9.116.226'" :mediaPort="'80'"></cameraPlayer>
            <!-- <cameraPlayer v-if="liftId==60" :videoCode="'21010200001320000901'" :audoCode="'21010200001320000901'" :wsUrl="'ws://139.9.116.226:181'" :mediaIp="'139.9.116.226'" :mediaPort="'80'"></cameraPlayer>
            <cameraPlayer v-if="liftId==61" :videoCode="'21010900991329000001'" :audoCode="'21010900991329000001'" :wsUrl="'ws://139.9.116.226:181'" :mediaIp="'139.9.116.226'" :mediaPort="'80'"></cameraPlayer> -->
            <!-- <div id="video-container"></div> -->
            <!-- <div class="videoBtn">
              <el-button type="primary" @click="back">发起对讲</el-button>
            </div> -->
          </div>
          <div class="rightBox">
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon1.png" />
              <span class="mr15">困人故障</span>
              <span class="fontVal" v-if="realTimeData.callState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.callState==1">困人</span>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon2.png" />
              <span class="mr15">冲顶故障</span>
              <span class="fontVal" v-if="realTimeData.elevatortoppingState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.elevatortoppingState==1">冲顶</span>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon3.png" />
              <span class="mr15">蹲底故障</span>
              <span class="fontVal" v-if="realTimeData.elevatorCrouchingState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.elevatorCrouchingState==1">蹲底</span>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon4.png" />
              <span class="mr15">门故障</span>
              <span class="fontVal" v-if="realTimeData.repeatedOpenAndClosingState==0&&realTimeData.runningOpenState==0&&realTimeData.closethedoorinplaceState==0&&realTimeData.doorMalfunction==0">正常</span>
              <div class="troubleBox">
                <span class="fontVal c-red" v-if="realTimeData.repeatedOpenAndClosingState==1">反复开关门故障</span>
                <span class="fontVal c-red" v-if="realTimeData.runningOpenState==1">运行中开关门故障</span>
                <span class="fontVal c-red" v-if="realTimeData.closethedoorinplaceState==1">长时间开门故障</span>
                <span class="fontVal c-red" v-if="realTimeData.doorMalfunction==1">遮挡门故障</span>
              </div>
              
            </div>
            <!-- <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon4.png" />
              <span class="mr15">反复开关门故障</span>
              <span class="fontVal" v-if="realTimeData.repeatedOpenAndClosingState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.repeatedOpenAndClosingState==1">异常</span>
            </div> -->
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon5.png" />
              <span class="mr15">基准层非平层故障</span>
              <span class="fontVal" v-if="realTimeData.notFlatLayerState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.notFlatLayerState==1">异常</span>
            </div>
            <!-- <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon6.png" />
              <span class="mr15">运行中开门故障</span>
              <span class="fontVal" v-if="realTimeData.runningOpenState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.runningOpenState==1">异常</span>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon7.png" />
              <span class="mr15">长时间开门故障</span>
              <span class="fontVal" v-if="realTimeData.closethedoorinplaceState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.closethedoorinplaceState==1">异常</span>
            </div> -->
            <!-- <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon8.png" />
              <span class="mr15">轿厢检修</span>
              <span class="fontVal" v-if="realTimeData.carriageoverhaulState==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.carriageoverhaulState==1">检修</span>
            </div> -->
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon9.png" />
              <span class="mr15">轿厢运行方向</span>
              <span class="fontVal" v-if="realTimeData.movingDirection==0">静止</span>
              <span class="fontVal" v-if="realTimeData.movingDirection==1">上行</span>
              <span class="fontVal" v-if="realTimeData.movingDirection==2">下行</span>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon14.png" />
              <span class="mr15">传感器故障</span>
              <span class="fontVal" v-if="realTimeData.horizontalSensor==0&&realTimeData.abnormalVibration==0&&realTimeData.resetOperation==0&&realTimeData.impatientStopError==0&&realTimeData.unmannedHighRun==0">正常</span>
              <div class="troubleBox">
                <span class="fontVal c-red" v-if="realTimeData.horizontalSensor==1">平层传感器故障</span>
                <span class="fontVal c-red" v-if="realTimeData.abnormalVibration==1">异常震动</span>
                <span class="fontVal c-red" v-if="realTimeData.resetOperation==1">复位运行</span>
                <span class="fontVal c-red" v-if="realTimeData.impatientStopError==1">急停异常</span>
                <span class="fontVal c-red" v-if="realTimeData.unmannedHighRun==1">无人高频运行</span>
              </div>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon15.png" />
              <span class="mr15">其他故障</span>
              <span class="fontVal" v-if="realTimeData.carriageAccidentMove==0&&realTimeData.carriageUnlockStop==0&&realTimeData.overSpeedFault==0&&realTimeData.outageCall==0&&realTimeData.oneTouchCall==0&&realTimeData.longMoving==0">正常</span>
              <div class="troubleBox">
                <span class="fontVal c-red" v-if="realTimeData.carriageAccidentMove==1">轿厢意外移动</span>
                <span class="fontVal c-red" v-if="realTimeData.carriageUnlockStop==1">轿厢在开锁区域外停止</span>
                <span class="fontVal c-red" v-if="realTimeData.overSpeedFault==1">超速故障</span>
                <span class="fontVal c-red" v-if="realTimeData.outageCall==1">断电故障</span>
                <span class="fontVal c-red" v-if="realTimeData.oneTouchCall==1">一键报警</span>
                <span class="fontVal c-red" v-if="realTimeData.longMoving==1">长时间运行故障</span>
              </div>
            </div>
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon16.png" />
              <span class="mr15">电瓶车入梯</span>
              <span class="fontVal" v-if="realTimeData.motorcycle==0">正常</span>
              <span class="fontVal c-red" v-if="realTimeData.motorcycle==1">异常</span>
            </div>
            <!-- <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon17.png" />
              <span class="mr15">乘客状态</span>
              <span class="fontVal" v-if="realTimeData.people==0">无人</span>
              <span class="fontVal c-red" v-if="realTimeData.people==1">有人</span>
            </div> -->
            <!-- <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon18.png" />
              <span class="mr15">轿门状态</span>
              <span class="fontVal" v-if="realTimeData.frontDoor==0">关闭</span>
              <span class="fontVal c-red" v-if="realTimeData.frontDoor==1">开启</span>
            </div> -->
            <div class="faultBox">
              <img class="faultImg" src="../../assets/imgs/liftIcon10.png" />
              <span class="mr15">电梯当前楼层</span>
              <span class="fontVal">{{realTimeData.liftLoction}}</span>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 实时数据 -->
      <el-card class="cardFlex">
        <div class="cardFlexTitle">实时数据</div>
        <div class="box">
          <div class="leftBox">
            <div class="faultTitle">轿厢运行方向</div>
            <el-table class="realTable" :data="realTimeData.movingDirectionsList" style="width: 100%">
              <el-table-column prop="CreateTime" label="更新时间">
                <template slot-scope="scope">
                  {{ scope.row.CreateTime|time}}
                </template>
              </el-table-column>
              <el-table-column prop="Value" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.Value == 0">静止</span>
                  <span v-if="scope.row.Value == 1">上行</span>
                  <span v-if="scope.row.Value == 2">下行</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="centerBox">
            <div class="container">
              <div id="echart1"></div>
            </div>
          </div>
          <div class="rightBox">
            <div class="container">
              <div id="echart2"></div>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 数据统计 -->
      <el-card class="cardFlex">
        <div class="cardFlexTitle">数据统计</div>
        <div class="box">
          <div class="leftBox">
            <div class="faultTitle">数据统计</div>
            <div class="sjtj">
              <div class="faultBox flex90">
                <img class="faultImg" src="../../assets/imgs/liftIcon11.png" />
                <span class="mr15">累计开门次数</span>
                <span class="bold">{{monitorData.openTheDoorNumberCount}}</span>
              </div>
              <div class="faultBox flex90">
                <img class="faultImg" src="../../assets/imgs/liftIcon12.png" />
                <span class="mr15">累计运行次数</span>
                <span class="bold">{{monitorData.runningTimesCount}}</span>
              </div>
              <div class="faultBox flex90">
                <img class="faultImg" src="../../assets/imgs/liftIcon13.png" />
                <span class="mr15">累计运行时长</span>
                <span class="bold">{{monitorData.runningTimeCount}}（分钟）</span>
              </div>
            </div>

          </div>
          <div class="centerBox">
            <div class="container">
              <div id="echart3"></div>
            </div>
          </div>
          <div class="rightBox">
            <div class="container">
              <div id="echart4"></div>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 电梯信息 -->
      <el-card class="cardFlex">
        <div class="cardFlexTitle">基本信息&电梯定位</div>
        <div class="box">
          <div class="leftBox pr20">
            <div class="faultTitle">基本信息</div>
            <el-form :model="ruleForm" name="frm" ref="ruleForm" class="form"
              :label-width="require('@/config/enum').c_ws7" :label-suffix="require('@/config/enum').c_colon">
              <el-form-item tem label="注册代码" prop="Registercode">
                <el-input type="text" v-model="ruleForm.Registercode" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="所在小区" prop="GardenName">
                <el-input type="text" v-model="ruleForm.GardenName" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="单位内部编号" prop="Unitinnernum">
                <el-input type="text" v-model="ruleForm.Unitinnernum" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="安装地址" prop="Place">
                <el-input type="text" v-model="ruleForm.Place" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="电梯类型" prop="DevName">
                <el-input type="text" v-model="ruleForm.DevName" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="电梯品牌" prop="Brand">
                <el-input type="text" v-model="ruleForm.Brand" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="使用单位" prop="Useunitidname">
                <el-input type="text" v-model="ruleForm.Useunitidname" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="维保单位" prop="Makeunitname">
                <el-input type="text" v-model="ruleForm.Makeunitname" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="使用单位联系人" prop="DutyPersonName">
                <el-input type="text" v-model="ruleForm.DutyPersonName" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="维保单位联系人" prop="Maintanman">
                <el-input type="text" v-model="ruleForm.Maintanman" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="使用单位电话" prop="DutyPersonPhone">
                <el-input type="text" v-model="ruleForm.DutyPersonPhone" disabled class="item-input"></el-input>
              </el-form-item>
              <el-form-item tem label="维保单位电话" prop="Cqphone">
                <el-input type="text" v-model="ruleForm.Cqphone" disabled class="item-input"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="rightBox pb20">
            <div class="faultTitle">电梯定位</div>
            <el-amap ref="map" vid="amapDemo" :center="center" :zoom="zoom" :events="events" class="amap">
              <el-amap-marker v-for="item in markers" :position="item.position" :key="item.id" :events="item.events"
                :label="item.label" :icon="item.icon"></el-amap-marker>
            </el-amap>
          </div>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
  /**
   *@ClassName:realTimeMonitoringDetail
   *@Description:电梯物联网实时监测详情
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'
  // import EZUIKit from 'ezuikit-js'
  // import '../../config/ezuikit.js'
  import gcoord from '../../../node_modules/gcoord'
  import dwImg from '../../assets/imgs/dw.png'
  import cameraPlayer from '../cameraPlayer/player'
  // var player
  var timer = null
  export default {
    name: '/manage/main.elevatorPortray',
    components: {
      cameraPlayer
    },
    data() {
      return {
        ruleForm: {}, // 从列表带过来的电梯数据信息
        liftId: '', // 电梯id
        startTs: '', // 开始时间
        endTs: '', // 结束时间
        realTimeData: '', // 实时数据
        monitorData: '', // 运行数据
        markers: [], // 定位标记点信息
        zoom: 12, // 缩放比例
        center: [], // 中心点坐标
        events: {
          'click': (e) => {
            console.log(e)
          }
        },
        videoURL: '', // 视频地址
        accessToken: '', // 萤石token
        switchValue: false, // 开关值
      }
    },
    beforeDestroy() {
      clearInterval(timer)
      // player.stop()
    },
    mounted() {
      this.ruleForm = this.$route.query.object
      console.log(this.ruleForm)
      console.log(this.ruleForm.YsNumber)
      var endTs = new Date().getTime()
      var startTs = endTs - 604800000
      this.endTs = endTs
      this.startTs = startTs
      this.liftId = this.$route.query.object.Id
      // this.getLiftToken()
      this.getRealTimeData()
      this.getOpenNumData()
      this.getRunTimeData()
      this.getMonitorData()
      this.initMap()
      // const that = this
      // timer = setInterval(function () {
      //   that.getRealTimeData()
      // }, 60000)
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.go(-1)
      },
      // 实时数据推送开关
      switchChange(e) {
        let loading = this.$loading()
        let sign = e ? 'startZlj' : 'stopZlj'
        this.$postJson(`aapi/setLiftInternetStartOrStop`, {
          'sign': sign,
          'token': 'zlj365',
          'regcode': this.ruleForm.Registercode,
        }).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (e) {
                this.$message.success('实时数据推送开启')
                const that = this
                timer = setInterval(function () {
                  that.getRealTimeData()
                }, 60000)
              } else {
                this.$message.info('实时数据推送关闭')
                clearInterval(timer)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 高频
      highRate() {
        clearInterval(timer)
        const that = this
        timer = setInterval(function () {
          that.getRealTimeData()
        }, 3000)
      },
      // 低频
      lowRate() {
        clearInterval(timer)
        const that = this
        timer = setInterval(function () {
          that.getRealTimeData()
        }, 60000)
      },
      // 获取萤石token
      // getLiftToken() {
      //   let loading = this.$loading()
      //   this.videoURL = 'ezopen://open.ys7.com/' + this.$route.query.object.YsNumber + '/1.hd.live'
      //   console.log(this.videoURL)
      //   this.$get(`aapi/getLiftToken`)
      //     .then(res => {
      //         loading.close()
      //         console.log(res)
      //         this.accessToken = res.accessToken
      //         this.initVideo()
      //       },
      //       error => {
      //         loading.close()
      //         this.$message.error(error)
      //       }
      //     )
      // },
      // 初始化视频
      // initVideo() {
      //   // 'at.74bhd1dz1oz09zcscywm1ylpbbc3o2x4-4ua3hbcd73-10sjjab-bafaihast'
      //   var offsetWidth = document.getElementById('video-container').offsetWidth
      //   player = new EZUIKit.EZUIKitPlayer({
      //     id: 'video-container', // 视频容器ID
      //     accessToken: this.accessToken,
      //     url: this.videoURL,
      //     template: 'security',
      //     width: offsetWidth,
      //     height: 500,
      //     footer: ['fullScreen']
      //   })
      //   player.play()
      //   // player.startTalk()
      // },
      // 初始化地图
      initMap() {
        var lng = this.$route.query.object.Longitude
        var lat = this.$route.query.object.Latitude
        // 转换坐标系
        let result = gcoord.transform(
          [lng, lat], // 经纬度坐标
          gcoord.WGS84, // 当前坐标系
          gcoord.GCJ02 // 目标坐标系
        )
        lng = result[0]
        lat = result[1]
        this.center.push(lng)
        this.center.push(lat)
        let pointMarker = [{
          lng: lng,
          lat: lat,
          Place: this.$route.query.object.Place
        }]
        pointMarker.forEach((item, index) => {
          this.markers.push({
            icon: dwImg,
            position: [item.lng, item.lat],
            label: {
              content: item.Place,
              offset: [-110, -30]
            }
          })
        })
      },
      // 获取页面实时数据
      getRealTimeData() {
        // let loading = this.$loading() 
        this.$get(
          `aapi/liftMonitorDataList?liftId=${this.liftId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            // loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.realTimeData = res
              console.log(this.realTimeData.liftSpeedsList)
              // 删除重复数据start
              let movingDirectionsArr = []
              let liftLoctionsArr = []
              let liftSpeedsArr = []
              for (let i = 0; i < this.realTimeData.movingDirectionsList.length; i++) {
                if (i == 0) {
                  movingDirectionsArr.push(this.realTimeData.movingDirectionsList[i])
                } else {
                  if (this.realTimeData.movingDirectionsList[i].Value != this.realTimeData.movingDirectionsList[i - 1].Value) {
                    movingDirectionsArr.push(this.realTimeData.movingDirectionsList[i])
                  }
                }
              }
              for (let j = 0; j < this.realTimeData.liftLoctionsList.length; j++) {
                if (j == 0) {
                  liftLoctionsArr.push(this.realTimeData.liftLoctionsList[j])
                } else {
                  if (this.realTimeData.liftLoctionsList[j].Value != this.realTimeData.liftLoctionsList[j - 1].Value) {
                    liftLoctionsArr.push(this.realTimeData.liftLoctionsList[j])
                  }
                }
              }
              for (let k = 0; k < this.realTimeData.liftSpeedsList.length; k++) {
                if (k == 0) {
                  liftSpeedsArr.push(this.realTimeData.liftSpeedsList[k])
                } else {
                  if (this.realTimeData.liftSpeedsList[k].value != this.realTimeData.liftSpeedsList[k - 1].value) {
                    liftSpeedsArr.push(this.realTimeData.liftSpeedsList[k])
                  }
                }
              }
              this.realTimeData.movingDirectionsList = movingDirectionsArr
              this.realTimeData.liftLoctionsList = liftLoctionsArr
              this.realTimeData.liftSpeedsList = liftSpeedsArr
              // 删除重复数据end
              console.log(this.realTimeData.liftSpeedsList)
              this.getLoadEcharts()
            }
          },
          error => {
            // loading.close()
            this.$message.error(error)
          })
      },
      // 获取开门次数统计数据
      getOpenNumData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftMonitorDataListByKey?key=OpenTheDoorNumber&liftId=${this.liftId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.openTheDoorNumberlist)
              // 图表3(当前楼层)X轴
              var createTimeList3 = (res.openTheDoorNumberlist).map((item) => {
                return this.formatDate1(item.createTime)
              })
              // 图表3(当前楼层)Y轴
              var valueList3 = (res.openTheDoorNumberlist).map((item) => {
                return item.value
              })
              var myChart3 = this.$echarts.init(
                document.getElementById('echart3')
              )
              var option3 = {
                title: {
                  text: '开门次数'
                },
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  data: createTimeList3
                },
                yAxis: {
                  type: 'value'
                },
                series: [{
                  name: '次数(次)',
                  type: 'line',
                  data: valueList3
                }]
              }
              myChart3.setOption(option3)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取运行时长统计数据
      getRunTimeData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftMonitorDataListByKey?key=RunningTime&liftId=${this.liftId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              // 图表4(运行速度)X轴
              var createTimeList4 = (res.runningTimeList).map((item) => {
                return this.formatDate(item.createTime)
              })
              // 图表4(运行速度)Y轴
              var valueList4 = (res.runningTimeList).map((item) => {
                return item.value
              })
              // 图表四
              var myChart4 = this.$echarts.init(
                document.getElementById('echart4')
              )
              var option4 = {
                title: {
                  text: '运行时长'
                },
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  data: createTimeList4
                },
                yAxis: {
                  type: 'value'
                },
                series: [{
                  name: '运行时长',
                  type: 'line',
                  data: valueList4
                }]
              }
              myChart4.setOption(option4)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取运行统计数据
      getMonitorData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftMonitorStatistics?liftId=${this.liftId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.monitorData = res
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取echarts图表(实时数据)
      getLoadEcharts() {
        // 图表1(当前楼层)X轴
        var CreateTimeList1 = (this.realTimeData.liftLoctionsList).map((item) => {
          // return this.formatDate(item.CreateTime)
          return ''
        })
        // 图表1(当前楼层)Y轴
        var valueList1 = (this.realTimeData.liftLoctionsList).map((item) => {
          return item.Value
        })
        // 图表2(运行速度)X轴
        var CreateTimeList2 = (this.realTimeData.liftSpeedsList).map((item) => {
          // return this.formatDate(item.createTime)
          return ''
        })
        // 图表2(运行速度)Y轴
        var valueList2 = (this.realTimeData.liftSpeedsList).map((item) => {
          return item.value
        })
        // 图表一
        var myChart1 = this.$echarts.init(
          document.getElementById('echart1')
        )
        var option1 = {
          title: {
            text: '电梯当前楼层'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          toolbox: {
            feature: {
              // saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: CreateTimeList1,
            axisLabel: {
              interval: 0,
              rotate: -20,
            }

          },
          dataZoom: [{
              type: 'inside',
              start: 0,
              end: 100
            },
            {
              start: 0,
              end: 100
            }
          ],
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '楼层',
            type: 'line',
            data: valueList1,
          }]
        }
        myChart1.setOption(option1)
        // 图表二
        var myChart2 = this.$echarts.init(
          document.getElementById('echart2')
        )
        var option2 = {
          title: {
            text: '运行速度（m/s）'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: CreateTimeList2,
            axisLabel: {
              interval: 0,
              rotate: -20,
            }
          },
          dataZoom: [{
              type: 'inside',
              start: 0,
              end: 100
            },
            {
              start: 0,
              end: 100
            }
          ],
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '速度',
            type: 'line',
            data: valueList2
          }]
        }
        myChart2.setOption(option2)
      },
      // 时间戳转换年月日时分秒
      formatDate(item) {
        let date = new Date(item)
        let YY = date.getFullYear() + '-'
        let MM =
          (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
        let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        let hh =
          (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        let mm =
          (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
          ':'
        let ss =
          date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        return YY + MM + DD + ' ' + hh + mm + ss
      },
      // 时间戳转换年月日
      formatDate1(item) {
        let date = new Date(item)
        let YY = date.getFullYear() + '-'
        let MM =
          (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
        let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        return YY + MM + DD
      },
    }
  }
</script>

<style lang="scss">
  .realTimeMonitoringDetail {
    .filters {
      .topBox {
        display: flex;
        justify-content: space-between;
        line-height: 1.7;
      }

      .address {
        font-size: 18px;
        padding-left: 10px;
        border-left: 3px solid #ff6207;
      }

      .el-button {
        margin: 0;
      }

      .layBox {
        display: flex;
        justify-content: space-between;

        .daysBox {
          width: 30%;
          text-align: center;
          margin-top: 20px;

          .daysNum {
            font-size: 26px;
            font-weight: bold;
            color: #00b1c3;
            margin-bottom: 10px;
          }

          .daysTxt {
            font-size: 18px;
          }
        }
      }
    }

    .cardBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .cardFlex {
      width: 100%;
      margin-bottom: 2%;

      .cardFlexTitle {
        font-size: 18px;
        padding-left: 10px;
        margin-left: 10px;
        margin-bottom: 30px;
        border-left: 3px solid #ff6207;
      }
    }

    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .el-card .el-card__body {
        width: 100%;
      }

      .leftBox {
        flex: 1;
      }

      .centerBox {
        flex: 1;
      }

      .rightBox {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
      }

      .realTable {
        width: 100%;
        flex: 1 0 39%;
        max-height: 330px;
        overflow-y: auto;
        display: grid;
        margin-left: 20px;
      }

      .faultBox {
        flex: 1 0 39%;
        display: flex;
        align-items: center;
        margin-left: 20px;
        margin-bottom: 20px;
        padding: 10px 20px;
        border: 1px solid #ddd;
      }

      .flex90 {
        flex: 1 0 90% !important;
      }

      .bold {
        font-weight: bold;
        margin-left: 30px;
      }

      .fontVal {
        font-weight: 800;
        margin-left: 30px;
      }

      .c-red {
        color: red;
      }

      .faultImg {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }

      .faultTitle {
        font-size: 18px;
        font-weight: 800;
        margin-bottom: 30px;
        margin-left: 10px;
      }

      .mr15 {
        display: inline-block;
        margin-right: 15px;
      }

      .pr20 {
        padding-right: 20px;
      }

      .pb20 {
        padding-bottom: 20px;
      }

      .sjtj {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .yxsj {
      display: flex;
      flex-wrap: wrap;
      padding-right: 10px;
      justify-content: space-between;
      margin-bottom: 30px;
    }

    .form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-right: 30px;

      .el-form-item {
        flex: 1 0 50%;
        align-items: center;
      }
    }

    .container {
      width: 30vw;
      height: 400px;
      margin-left: 30px;
    }

    .el-switch__core {
      width: 50px !important;
      height: 20px;
    }

    .el-switch__core::after {
      width: 18px;
      height: 18px;
      margin-top: -1px;
    }

    .el-switch.is-checked .el-switch__core::after {
      margin-left: -19px;
    }

    #echart1,
    #echart2,
    #echart3,
    #echart4{
      width: 90%;
      height: 100%;
    }

    .el-input.is-disabled .el-input__inner {
      color: #606266;
    }

    .amap {
      width: 100%;
      height: 90%;
    }

    .amap-marker-label {
      position: absolute;
      z-index: 2;
      border: 1px solid red;
      background-color: white;
      white-space: nowrap;
      cursor: default;
      padding: 3px;
      font-size: 18px;
      line-height: 18px;
      color: red;
    }

    .amap-icon img {
      width: 36px;
    }

    #video-container {
      // width: 100%;
      height: 85%;
    }

    .videoBtn {
      margin-top: 15px;
      text-align: center;
    }
    .troubleBox span{
      display: block;
      font-size: 14px;
    }
  }
</style>